// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-27Nlk";
var _3 = "text-33A0i";
var _4 = "signIn-3oUf_";
var _5 = "signIn__skip-2a13F";
export { _1 as "__esModule", _2 as "wrapper", _3 as "text", _4 as "signIn", _5 as "signIn__skip" }
export default { "__esModule": _1, "wrapper": _2, "text": _3, "signIn": _4, "signIn__skip": _5 }
